// extracted by mini-css-extract-plugin
export default {"header":"partners_header__uCypO","partners":"partners_partners__zPxcD","partners-header":"partners_partners-header__Ko8i7"};